import React from 'react';
import { Grid, TextField, Typography } from '@mui/material';

const METRICS = [
  { key: 'requests', label: 'Requests' },
  { key: 'credits', label: 'Créditos' },
  { key: 'tokens', label: 'Tokens' }
];
const WINDOWS = [
  { key: 'minute', label: 'por minuto' },
  { key: 'hour', label: 'por hora' }
];

const darkTextFieldStyle = {
  '& .MuiOutlinedInput-root': {
    color: 'var(--wb-text-strong)',
    '& fieldset': { borderColor: 'var(--wb-outline)' },
    '&:hover fieldset': { borderColor: 'var(--wb-text-dim)' }
  },
  '& .MuiInputLabel-root': { color: 'var(--wb-text-soft)' }
};

/**
 * Grid cerrado 3x2 ({requests,credits,tokens} x {minute,hour}) para el
 * campo `throughput` que comparten Account/User Credit Policy y
 * Subscription Plan — todos con la misma forma
 * `{metric: {window: limite}}`, vacío = sin límite.
 */
const ThroughputFieldsGrid = ({ value = {}, onChange, label = 'Throughput (opcional, vacío = sin límite)' }) => {
  const handleChange = (metric, window) => (event) => {
    const raw = event.target.value;
    const next = { ...value };
    next[metric] = { ...(next[metric] || {}) };
    if (raw === '') {
      delete next[metric][window];
      if (Object.keys(next[metric]).length === 0) {
        delete next[metric];
      }
    } else {
      next[metric][window] = raw;
    }
    onChange(next);
  };

  return (
    <div>
      <Typography sx={{ color: 'var(--wb-text-soft)', mb: 1, fontSize: '0.85rem' }}>{label}</Typography>
      <Grid container spacing={1.5}>
        {METRICS.map((metric) => (
          <Grid item xs={12} key={metric.key}>
            <Grid container spacing={1.5} alignItems="center">
              <Grid item xs={3}>
                <Typography sx={{ color: 'var(--wb-text)', fontSize: '0.85rem' }}>{metric.label}</Typography>
              </Grid>
              {WINDOWS.map((window) => (
                <Grid item xs={4} key={window.key}>
                  <TextField
                    label={window.label}
                    value={value?.[metric.key]?.[window.key] ?? ''}
                    onChange={handleChange(metric.key, window.key)}
                    type="number"
                    inputProps={{ step: '1', min: 0 }}
                    fullWidth
                    size="small"
                    sx={darkTextFieldStyle}
                  />
                </Grid>
              ))}
            </Grid>
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default ThroughputFieldsGrid;
